import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Contact {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  contact_type: string;
  created_at: string;
}

export default function Contacts() {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', email: '', phone: '', contact_type: 'lead' });

  useEffect(() => {
    loadContacts();
  }, []);

  async function loadContacts() {
    try {
      setLoading(true);
      const res = await api.get('/api/contacts');
      setContacts(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api.post('/api/contacts', form);
      setForm({ name: '', email: '', phone: '', contact_type: 'lead' });
      loadContacts();
    } catch (err: any) {
      setError(err.message);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Contacts</h1>
      {error && <div style={styles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          style={styles.input}
          required
        />
        <input
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          style={styles.input}
        />
        <input
          placeholder="Phone"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          style={styles.input}
        />
        <select
          value={form.contact_type}
          onChange={(e) => setForm({ ...form, contact_type: e.target.value })}
          style={styles.input}
        >
          <option value="lead">Lead</option>
          <option value="customer">Customer</option>
          <option value="partner">Partner</option>
          <option value="vendor">Vendor</option>
        </select>
        <button type="submit" style={styles.button}>Add Contact</button>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Phone</th>
              <th style={styles.th}>Type</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr key={c.id}>
                <td style={styles.td}>{c.name}</td>
                <td style={styles.td}>{c.email}</td>
                <td style={styles.td}>{c.phone}</td>
                <td style={styles.td}>{c.contact_type}</td>
              </tr>
            ))}
            {contacts.length === 0 && (
              <tr>
                <td colSpan={4} style={{ ...styles.td, textAlign: 'center', color: '#9ca3af' }}>
                  No contacts yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  form: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: 14, border: '1px solid #e5e7eb', borderRadius: 6, minWidth: 140 },
  button: { padding: '8px 16px', fontSize: 14, background: '#111827', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#6b7280' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};
